import { render } from "./Alert.vue?vue&type=template&id=fb7e4952"
import script from "./Alert.vue?vue&type=script&lang=js"
export * from "./Alert.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/Components/Alert.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fb7e4952"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fb7e4952', __exports__)) {
    api.reload('fb7e4952', __exports__)
  }
  
  module.hot.accept("./Alert.vue?vue&type=template&id=fb7e4952", () => {
    api.rerender('fb7e4952', render)
  })

}


export default __exports__